export class ResponsaveisFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getResponsaveis(search) {
    return this.instance.get('/v1/rastreabilidade/responsaveis', {
      params: { search: search?.trim() || '' },
    });
  }
}

export default (...params) => new ResponsaveisFactory(...params);
